const faqs = [
  {
    q: '极速影院真的完全免费吗？需要注册吗？',
    a: '是的，极速影院所有综艺节目完全免费在线观看，无需注册账号，无需充值会员，打开网站即可直接观看。我们通过合理的广告运营来维持平台运行，不会向用户收取任何费用。',
  },
  {
    q: '综艺节目的画质怎么样？支持高清播放吗？',
    a: '极速影院全站综艺节目均支持1080P超清画质播放。我们采用先进的视频编码和CDN加速技术，确保在提供高清画质的同时，依然保持流畅不卡顿的观看体验。',
  },
  {
    q: '节目更新速度快吗？能看到最新一期吗？',
    a: '极速影院保持每日同步更新，各档热门综艺节目播出后我们会第一时间上线最新期数。你可以在"最新动态"栏目中查看近期更新的节目列表，确保不错过任何一期精彩内容。',
  },
  {
    q: '手机和平板上可以观看吗？需要下载APP吗？',
    a: '当然可以！极速影院网页版已完美适配手机和平板浏览器，无需下载任何APP。在浏览器中打开网站即可畅享移动观影体验，我们还提供了省流模式和深色护眼模式，让移动观影更加舒适。',
  },
];

export default function SectionFaq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            关于极速影院，你可能想了解的一切
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-background-50 rounded-xl p-5 md:p-6">
              <div className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-background-50 text-xs font-bold">Q</span>
                </div>
                <div>
                  <h3 className="text-base font-bold text-foreground-950 font-heading">
                    {faq.q}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}